import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Linkedin, Github } from "lucide-react";
import KolMyGlassLogo from "./KolMyGlassLogo";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = "" }) => {
  return (
    <footer
      className={`border-t border-white/10 bg-[#0a0f1e]/80 py-16 backdrop-blur-sm ${className}`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 mb-12">
          <div className="md:col-span-2">
            <Link
              to="/"
              className="mb-4 inline-flex shrink-0 items-center outline-none ring-offset-2 ring-offset-[#0a0f1e] focus-visible:ring-2 focus-visible:ring-violet-500/80"
            >
              <KolMyGlassLogo variant="nav" forDarkBackground />
            </Link>
            <p className="text-gray-400 mb-6 max-w-xs">
              Influencer Marketing AI Platform helping brands and agencies scale
              their campaigns.
            </p>
            <div className="flex gap-3">
              <div className="w-10 h-10 border border-white/10 rounded-full flex items-center justify-center text-gray-400 hover:border-violet-500 hover:text-violet-500 transition-colors">
                <Twitter className="w-4 h-4" />
              </div>
              <div className="w-10 h-10 border border-white/10 rounded-full flex items-center justify-center text-gray-400 hover:border-violet-500 hover:text-violet-500 transition-colors">
                <Linkedin className="w-4 h-4" />
              </div>
              <div className="w-10 h-10 border border-white/10 rounded-full flex items-center justify-center text-gray-400 hover:border-violet-500 hover:text-violet-500 transition-colors">
                <Github className="w-4 h-4" />
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/features"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/login"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Guides
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Privacy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Terms
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Cookies
                </Link>
              </li>
              <li>
                <Link
                  to="/compliance"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Compliance
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © 2026 QueueMart 1260221-X All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy"
              className="text-gray-500 hover:text-white transition-colors text-sm"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-gray-500 hover:text-white transition-colors text-sm"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
